import React from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import SydButton from '../../../../commonDesign/Button'
import FieldDisplay from '../../../../molecules/FieldDisplay'

function SettingsTab ({ blueprint, onAddDefinition }) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <h2>Blueprint Information</h2>
        <FieldDisplay
          fields={[
            { label: 'ID', value: blueprint.blueprintId },
            { label: 'Code', value: blueprint.code },
            { label: 'Name', value: blueprint.name },
            { label: 'Enabled', value: blueprint.enabled ? 'Yes' : 'No' },
            { label: 'Description', value: blueprint.description || '—' },
            { label: 'Active Version', value: blueprint.definitionVersionId || 'None' }
          ]}
        />
      </Grid>

      <Grid item xs={12} style={{ display: 'flex', gap: '8px' }}>
        <SydButton variant='primary' size='sm' icon='add' onClick={onAddDefinition}>
          Add Version
        </SydButton>
      </Grid>
    </Grid>
  )
}

SettingsTab.propTypes = {
  blueprint: PropTypes.object.isRequired,
  onAddDefinition: PropTypes.func.isRequired
}

export default SettingsTab
